import { themeV2 } from '@features/lci-report/domain/theme-v2';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants-v2';
import type {
  BorderProps,
  Slide,
  TableCell,
  TableOptions,
  TableRow,
} from '@features/powerpoint';

export type MinimumsTableV2Data = {
  headers: string[];
  body: string[][];
};

type MinimumsTableV2Props = {
  options: TableOptions;
  data: MinimumsTableV2Data;
};

const NO_BORDER: BorderProps = { type: 'none' };
const SEPARATOR: BorderProps = {
  type: 'solid',
  color: themeV2.colors.magnetBlue,
  pt: 1,
};

const leftCellBorders: [BorderProps, BorderProps, BorderProps, BorderProps] = [
  NO_BORDER,
  SEPARATOR,
  SEPARATOR,
  NO_BORDER,
];

const rightCellBorders: [BorderProps, BorderProps, BorderProps, BorderProps] = [
  NO_BORDER,
  NO_BORDER,
  SEPARATOR,
  NO_BORDER,
];

const buildRow = (cells: TableCell[]): TableRow =>
  cells.map(
    (cell, index): TableCell => ({
      text: cell.text,
      options: {
        valign: 'middle',
        fontFace: DEFAULT_FONT,
        align: index === 0 ? 'right' : 'left',
        border: index === 0 ? leftCellBorders : rightCellBorders,
        ...cell.options,
      },
    })
  );

export const minimumsTableV2 = (props: MinimumsTableV2Props): Slide => {
  const { data, options } = props;

  const headerRow = buildRow(
    data.headers.map(header => ({
      text: header,
      options: {
        bold: true,
        color: themeV2.colors.metricBlue,
      },
    }))
  );

  const bodyRows = data.body.map(row =>
    buildRow(row.map(cell => ({ text: cell })))
  );

  return {
    tables: [
      {
        tableRows: [headerRow, ...bodyRows],
        options: {
          autoPage: true,
          fontSize: 12,
          fontFace: DEFAULT_FONT,
          color: themeV2.colors.metricBlue,
          ...options,
        },
      },
    ],
  };
};
